import { render, staticRenderFns } from "./existing-account-footer.vue?vue&type=template&id=6681a572&"
import script from "./existing-account-footer.vue?vue&type=script&lang=js&"
export * from "./existing-account-footer.vue?vue&type=script&lang=js&"
import style0 from "./existing-account-footer.vue?vue&type=style&index=0&id=6681a572&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports